import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShopCartPreviewService {
    private readonly miniCartPreviewVisible$ = new BehaviorSubject<boolean>(false);

    public readonly isMiniCartPreviewVisible$ = this.miniCartPreviewVisible$.asObservable();

    public showMiniCartPreview(): void {
        this.miniCartPreviewVisible$.next(true);
    }

    public hideMiniCartPreview(): void {
        this.miniCartPreviewVisible$.next(false);
    }
}
